import type { TeamworkGraphPerson } from '@confluence/twg-graph-explorer/entry-points/teamworkGraphModel.ts';

/** The canvas selects up to four entries from the shared ranking. */
export const MAX_PAGE_PEOPLE = 4;

/** The maximum number of rows in the expanded People & Agents section. */
export const MAX_LISTED_PAGE_PEOPLE = 10;

/** The account ID is retained for human profile links in the section. */
export type RankedPagePerson = TeamworkGraphPerson & { accountId: string };
